// extracted by mini-css-extract-plugin
export default {"container":"CoffeePath_container__ju6mW","navigation":"CoffeePath_navigation__KFQcF","navigationItem":"CoffeePath_navigationItem__fF+59"};